import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { UserModule } from '@/store/modules/user';
import { PermissionModule } from '@/store/modules/permission';
import i18n from '@/lang'; // Internationalization
import settings from './settings';
NProgress.configure({
  showSpinner: false
});
var whiteList = ['/login', '/auth-redirect'];
var getPageTitle = function getPageTitle(key) {
  var hasKey = i18n.te("route.".concat(key));
  if (hasKey) {
    var pageName = i18n.t("route.".concat(key));
    return "".concat(pageName, " - ").concat(settings.title);
  }
  return "".concat(settings.title);
};
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, _, next) {
    var url, params, token, roles, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // Start progress bar
          NProgress.start();
          if (!UserModule.token || !UserModule.token.access_token) {
            url = new URL(window.location.href);
            params = new URLSearchParams(url.search);
            if (params.get('accessToken')) {
              token = {
                access_token: params.get('accessToken'),
                token_type: 'bearer'
              };
              UserModule.setToken(token);
              window.location.replace('/');
            }
          }
          // Determine whether the user has logged in
          if (!(UserModule.token && UserModule.token.access_token)) {
            _context.n = 8;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 1;
            break;
          }
          // If is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 7;
          break;
        case 1:
          if (!(UserModule.roles.length === 0)) {
            _context.n = 6;
            break;
          }
          _context.p = 2;
          _context.n = 3;
          return UserModule.GetUserInfo();
        case 3:
          roles = UserModule.roles; // Generate accessible routes map based on role
          PermissionModule.GenerateRoutes(roles);
          // Dynamically add accessible routes
          router.addRoutes(PermissionModule.dynamicRoutes);
          // Hack: ensure addRoutes is complete
          // Set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          // Remove token and redirect to login page
          UserModule.ResetToken();
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 5:
          _context.n = 7;
          break;
        case 6:
          next();
        case 7:
          _context.n = 9;
          break;
        case 8:
          // Has no token
          if (whiteList.indexOf(to.path) !== -1) {
            // In the free login whitelist, go directly
            next();
          } else {
            // Other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 9:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // Finish progress bar
  NProgress.done();
  // set page title
  document.title = getPageTitle(to.meta.title);
});